import React from 'react'
import { NumericFormat } from 'react-number-format';


export const PercentFormatInput = React.forwardRef(function NumericFormatCustom(
  props,
  ref,
) {
  const {onChange, ...other } = props;

  return (
    <NumericFormat
    {...other}
    getInputRef={ref}
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={2}
    suffix="%"
    fixedDecimalScale
    valueIsNumericString
    onValueChange={(values) => {
        const { value } = values; // Obtém o valor formatado
        const numericValue = parseFloat(value); // Converte para número

        if(isNaN(numericValue)){
         
          onChange({
            target: {
                name: props.name,
                value: "", // Atualiza o valor se estiver dentro do intervalo
            },
          });
          return 
          
        }

        // Verifica se o valor está dentro do intervalo permitido
        if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 3) {
            onChange({
                target: {
                    name: props.name,
                    value: numericValue, // Atualiza o valor se estiver dentro do intervalo
                },
            });
        }
    }}
    isAllowed={({ floatValue }) => {
        // Permite apenas valores entre 0 e 3
        return floatValue === undefined || (floatValue >= 0 && floatValue <= 3);
    }}
/>
  )
}
)



